// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import api from 'lib/Api';
import alertActions from 'ducks/alert/actions';
import type { Saga } from 'redux-saga';
import { push } from 'connected-react-router';
import { alertTypesConstants } from 'commons/constants/index';
import { getNewLandingPageTypes } from './types';
import { newLandingPageActions } from './actions';

const { DANGER } = alertTypesConstants;
export function* getNewLandingPageSaga({ payload }: { payload: Record<string, any> }): Saga<void> {
  try {
    const response = yield call([api.newLandingPage, 'getNewLandingPage'], payload, payload.type);
    yield put(newLandingPageActions.getNewLandingPageSuccess(response));
  } catch (error) {
    yield put(
      alertActions.setAlert({
        message: 'There was an error fetching the Area of Interest!',
        type: DANGER,
      }),
    );
    yield put(newLandingPageActions.getNewLandingPageFailed(error));
    yield put(push('/404'));
  }
}
export default function* newLandingPageSaga(): Saga<void> {
  yield takeLatest(getNewLandingPageTypes.REQUEST, getNewLandingPageSaga);
}
